module.exports = __webpack_public_path__ + "static/media/pick-by-design.d1092940.png";